import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import ShiftDataTable from "./ShiftDataTable";
import { withoutActualBuckets } from "../../../utils/midShiftActuals";
import { selectIsMidShiftReplanEnabled } from "../../../store/slices/v2/midShiftReplanFeatureSlice";

const selectShiftSummary = (state: RootState) => state.reviewAndPublish.shiftPlanOutput?.shiftSummary;

// Memoised so the table gets a stable reference between store updates. Flag off: the mid-shift
// actual hours are dropped so the table reads as today (projected only).
const selectGatedShiftSummary = createSelector(
    [selectShiftSummary, selectIsMidShiftReplanEnabled],
    (shiftSummary, showActuals) => (showActuals ? shiftSummary : withoutActualBuckets(shiftSummary))
);

const mapStateToProps = (state: RootState) => ({
    shiftSummary: selectGatedShiftSummary(state),
    // RCC_MID_SHIFT_REPLAN, resolved into Redux by the page (useResolveMidShiftReplan).
    showActuals: selectIsMidShiftReplanEnabled(state),
    isDarkMode: state.theme.currentMode === "dark",
});

export default connect(mapStateToProps)(ShiftDataTable);
